import {getColor} from "@/styles/ThemeConfig";
import Image from "next/image";
import styled from "styled-components";
import {breakpoints} from "@/styles/sizes";
import ForceSSRLink from "@/components/other/ForceSSRLink";
import {useRouter} from "next/router";
import {useEffect} from "react";

const SocialLink = styled.a`
    width: 40px;
    height: 40px;

    display: flex;
    justify-content:center;
    align-items:center;
    transition: 0.3s ease;

    border:1px solid ${getColor('gold')};
    border-radius:100%;

    img{
        object-fit: contain;
    }

    :hover{
        background-color: rgba(0,0,0,0.5);
    }
`

const Wrapper = styled.div`
    background: ${getColor('green')};
    color: white;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    justify-content: center;
    padding-top:100px;
    padding-bottom:25px;
    overflow: hidden;
    @media only screen and (${breakpoints.mobile}) {
        padding:25px;
    }
`;


const FooterWrapper = styled.div`
    display: grid;
    grid-template-columns: 4fr 3fr 3fr;

    gap:50px;

    padding:0 50px;
    @media only screen and (${breakpoints.mobile}) {
        padding:0;
    }
    #col1{
        order:1;
    }
    #col2{
        order:2;
    }
    #col3{
        order:3;
    }

    @media only screen and (${breakpoints.mobile}) {
        grid-template-columns: 1fr;

        #col1{
            order:1;
        }
        #col2{
            order:3;
        }
        #col3{
            margin-top:30px;
            order:2;
        }
    }
`;


const FormWrapper = styled.div`

    @media only screen and (${breakpoints.mobile}) {
        margin-bottom: 50px;
    }
`;


const FooterLinksWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 0px;
    @media only screen and (${breakpoints.mobile}) {
        margin-top:50px;
        margin-bottom:50px;
    }
`;




const LinksTitle = styled.div`
    text-transform: uppercase;
    font-family: 'Josefin Sans',sans-serif;
    font-size: 18px;
    color: ${getColor('gold')};
    margin-bottom: 20px;

    @media only screen and (${breakpoints.mobile}) {
    }
`;

const LinksList = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap:20px;
    margin-bottom: 30px;

    a{
        color:white!important;
        text-decoration: none;
        font-family: 'Josefin Sans',sans-serif;
        font-size: 16px;
    }

    @media only screen and (${breakpoints.mobile}) {
    }
`;


const FooterBarWrapper = styled.div`
    width:100%;
    display:flex;
    justify-content:space-between;
    align-items:center;
    padding: 0 50px;
    .proudMembers{
        display:flex;
        justify-content:flex-start;
        align-items:center;
        gap:30px;
    }

    @media only screen and (${breakpoints.mobile}) {
        flex-direction: column;

        .proudMembers{
            display:flex;
            flex-direction: column;
            justify-content:flex-start;
            align-items:center;
            gap:20px;
            margin-bottom: 20px;
        }
    }
`;



export default function FooterNew({footerData,socialLinks})
{
    const router = useRouter();

    useEffect(() => {
        if (router.isReady && router.asPath.includes("#form") || router.asPath.includes("#FORM")) {
            setTimeout(() => {
                if(router.asPath.includes("#form")){
                    const section = document.getElementById("form");
                    if (section) {
                        section.scrollIntoView({ behavior: "smooth" });
                    }
                }else if(router.asPath.includes("#FORM")){
                    const section = document.getElementById("FORM");
                    if (section) {
                        section.scrollIntoView({ behavior: "smooth" });
                    }
                }
            },500)
        }
    }, [router]);


    const links1aTitle = footerData?.data?.['links1aTitle'] ?? null;
    const links1a = footerData?.data?.links?.['1a'] ?? [];

    const links1bTitle = footerData?.data?.['links1bTitle'] ?? null;
    const links1b = footerData?.data?.links?.['1b'] ?? [];

    const links2aTitle = footerData?.data?.['links2aTitle'] ?? null;
    const links2a = footerData?.data?.links?.['2a'] ?? [];

    const links2bTitle = footerData?.data?.['links2bTitle'] ?? null;
    const links2b = footerData?.data?.links?.['2b'] ?? [];

    const legalText = (footerData?.data?.legalText ??
        'Essor Ltd. © {year} - Secret Food Tours is a trading name and registered trademark of Essor ltd. Registered in England and Wales company no 8368703. Founded in 2013.').replaceAll('{year}', new Date().getFullYear());

    return <Wrapper>

        <div className={'container'}>
            <FooterWrapper>

                {/* COLUMN 1 */}
                <div id={'col1'}>


                    <Image
                        width={256}
                        height={256}
                        src={footerData?.logo?.url}
                        alt={footerData?.logo?.alt ?? footerData?.logo?.name}
                        style={{
                            width: '256px',
                            height: 'auto',
                            marginBottom:'25px',
                        }}
                    />
                    <div style={{fontSize:'24px', textTransform:'uppercase', marginBottom:'15px'}}>
                        {footerData?.data?.title}
                        <span style={{fontSize:'24px',fontWeight:'bold', textTransform:'uppercase'}}> {footerData?.data?.subtitle}</span>
                    </div>

                    <div style={{
                        marginBottom:'50px',
                        fontWeight:300,
                    }}>
                        <span style={{
                        }}>{legalText}</span>
                    </div>

                    <div>
                        {footerData?.recommendationImages?.map((item, index) => {
                            return <Image key={index} width={350} height={500} src={item?.url} alt={item?.alt ?? item?.name}
                                          style={{
                                              width: 'auto',
                                              maxWidth:'100%',
                                              height: 'auto',
                                          }}/>
                        })}
                    </div>

                </div>




                {/* COLUMN 2 */}

                <FooterLinksWrapper id={'col2'}>
                    <div>
                        {
                            (links1aTitle && links1a?.length !== 0) && <>
                                <LinksTitle>{links1aTitle}</LinksTitle>
                                <LinksList>
                                    {
                                        links1a?.map((item,index) => {
                                            return <a href={item?.item_link} key={index}>
                                                {item?.item_title}
                                            </a>
                                        })
                                    }
                                </LinksList>
                            </>
                        }

                        {
                            (links1bTitle && links1b?.length !== 0) && <>
                                <LinksTitle>{links1bTitle}</LinksTitle>
                                <LinksList>
                                    {
                                        links1b?.map((item,index) => {
                                            return <a href={item?.item_link} key={index}>
                                                {item?.item_title}
                                            </a>
                                        })
                                    }
                                </LinksList>
                            </>
                        }
                    </div>

                    <div>
                        {
                            (links2aTitle && links2a?.length !== 0) && <>
                                <LinksTitle>{links2aTitle}</LinksTitle>
                                <LinksList>
                                    {
                                        links2a?.map((item,index) => {
                                            return <a href={item?.item_link} key={index}>
                                                {item?.item_title}
                                            </a>
                                        })
                                    }
                                </LinksList>
                            </>
                        }

                        {
                            (links2bTitle && links2b?.length !== 0) && <>
                                <LinksTitle>{links2bTitle}</LinksTitle>
                                <LinksList>
                                    {
                                        links2b?.map((item,index) => {
                                            return <ForceSSRLink href={item?.item_link} key={index}>
                                                {item?.item_title}
                                            </ForceSSRLink>
                                        })
                                    }
                                </LinksList>
                            </>
                        }
                    </div>
                </FooterLinksWrapper>




                {/* COLUMN 3 */}

                <FormWrapper id={'col3'}>
                    <LinksTitle>{footerData?.data?.form_title}</LinksTitle>
                    <p style={{marginBottom:'20px'}}>{footerData?.data?.form_subtitle}</p>

                    <div dangerouslySetInnerHTML={{__html: footerData?.data?.form}}/>
                </FormWrapper>




            </FooterWrapper>
        </div>


        <div
            style={{
                width:'100%',
                borderTop:`1px solid ${getColor('lightGreen')}`,
                paddingTop:'25px',
            }}
        >
            <div className={'container'}>
                <FooterBarWrapper>
                    <div
                        id={'form'}
                        className={'proudMembers'}
                    >
                        <div style={{
                            fontSize:'16px',
                            textTransform:'uppercase',
                        }}>{footerData?.data?.proudMembersTitle}</div>

                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '30px'
                        }}>
                            {footerData?.proudMembersImages?.map((item, index) => {
                                return <Image key={index} width={300} height={26} src={item?.url} alt={item?.alt ?? item?.name}
                                              style={{
                                                  width: 'auto',
                                                  height: '26px',
                                              }}/>
                            })}
                        </div>
                    </div>

                    <div>
                        <div style={{
                            display:'flex',
                            alignItems:'center',
                            justifyContent:'flex-end',
                            gap:'10px',
                        }}>
                            {socialLinks?.map((item, index) => {
                                return <SocialLink
                                    key={index}
                                    style={{
                                    }}
                                    href={item?.url}
                                    target={'_blank'}
                                >
                                    <Image key={index} width={15} height={15} src={item?.image?.url}
                                           alt={item?.image?.alt ?? item?.image?.name}
                                           style={{
                                               width: '15px',
                                               height: '15px',
                                           }}/>
                                </SocialLink>

                            })}
                        </div>
                    </div>
                </FooterBarWrapper>
            </div>
        </div>


    </Wrapper>
}
